// extracted by mini-css-extract-plugin
module.exports = {"close":"styles-module__close___31RCA","modalBody":"styles-module__modalBody___2WbeC"};